import axios from 'axios';

if (!process.env.REACT_APP_SITE_URL) {
    throw new Error('REACT_APP_SITE_URL is not set!');
}

const api = axios.create({
    baseURL: `${process.env.REACT_APP_SITE_URL}/wp-json/v2`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false,
});

api.interceptors.request.use(
    async (config) => {
        return config;
    },
    (error) => {
        console.error(error);
    }
);

api.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error.hasOwnProperty('message')) {
            console.error('⚠️⚠️⚠️ Ошибка в ASK Конструкторе ⚠️⚠️⚠️\n\n' + error.message.trim());
        } else {
            console.error(error);
        }

        throw error;
    }
);

export default api;
